import index from '@/components/conf/index/index.vue'
import empty from '@/components/common/empty/empty.vue'
export default {
  path: '/life-home',
  component: index,
  redirect: '/life-home/home',
  name: '小步生活家',
  iconCls: '&#xe794;',
  children: [{
    path: 'home',
    component: empty,
    name: '首页推荐配置',
    iconCls: '&#xe803;',
    hiddenChildren: true,
    redirect: '/life-home/home/list',
    children: [{
      path: 'list',
      component: resolve => require(['@/components/conf/life-home/home/index.vue'], resolve),
      name: '首页推荐配置'
    },{
      path: 'swiper/add',
      component: resolve => require(['@/components/conf/life-home/home/swiper/index.vue'], resolve),
      name: '广告图添加'
    },{
      path: 'article/add',
      component: resolve => require(['@/components/conf/life-home/home/article/index.vue'], resolve),
      name: '文章添加'
    }]
  },{
    path: 'classify',
    component: resolve => require(['@/components/conf/life-home/classify/index.vue'], resolve),
    name: '分类管理',
    iconCls: '&#xe803;'
  },{
    path: 'label',
    component: resolve => require(['@/components/conf/life-home/label/index.vue'], resolve),
    name: '标签管理',
    iconCls: '&#xe7f8;'
  },{
    path: 'daren',
    component: empty,
    name: '达人管理',
    iconCls: '&#xe803;',
    redirect: '/life-home/daren/list',
    hiddenChildren: true,
    children: [{
      path: 'list',
      component: resolve => require(['@/components/conf/life-home/daren/index.vue'], resolve),
      name: '达人管理列表'
    },{
      path: 'add',
      component: resolve => require(['@/components/conf/life-home/daren/add.vue'], resolve),
      name: '达人添加'
    }]
  },{
    path: 'article',
    component: empty,
    name: '文章管理',
    iconCls: '&#xe803;',
    redirect: '/life-home/article/list',
    hiddenChildren: true,
    children: [{
      path: 'list',
      component: resolve => require(['@/components/conf/life-home/article/index.vue'], resolve),
      name: '文章管理列表'
    },{
      path: 'add',
      component: resolve => require(['@/components/conf/life-home/article/add.vue'], resolve),
    }]
  }]
}



// WEBPACK FOOTER //
// ./src/router/life-home.js